/**
 * Whether the simple view's "In this conversation" column shows, and how it closes. It shows when the person opened it
 * (a saved preference) or when a record is open in it (`?panel=`, set by a card's Open control); closing it closes the
 * record too.
 */
import { useContextPanel } from '../../components/context-panel/url-state.js';
import { useUIStore } from '../../store/index.js';

export function useSimpleRecordsColumn(): { visible: boolean; open: () => void; close: () => void } {
  const preferred = useUIStore((s) => s.conversationRecordsOpen);
  const setPreferred = useUIStore((s) => s.setConversationRecordsOpen);
  const { panel, closePanel } = useContextPanel();
  return {
    visible: preferred || panel !== null,
    open: () => setPreferred(true),
    close: () => {
      setPreferred(false);
      if (panel !== null) closePanel();
    },
  };
}
